import { useState } from "react";
import { Slider, TextField } from "@mui/material";

export default function TransportCalculator() {
  const [weight, setWeight] = useState(1); // кг
  const [dimensions, setDimensions] = useState({
    өргөн: 1, // см
    өндөр: 1, // см
    урт: 1, // см
  });

  const UNIT_PRICE_WEIGHT = 2000; // ₮/кг
  const UNIT_PRICE_VOLUME_UNDER_1M3 = 699; // ¥ / м³
  const UNIT_PRICE_VOLUME_OVER_1M3 = 499; // ¥ / м³
  const EXCHANGE_RATE = 520; // ₮ / ¥

  const formatMoney = (n) =>
    n.toLocaleString("en-US", { maximumFractionDigits: 0 });

  const calculateTotalPrice = () => {
    const { өргөн, өндөр, урт } = dimensions;
    const volume_m3 = (өргөн * өндөр * урт) / 1_000_000;

    const unitPriceVolume =
      volume_m3 <= 1 ? UNIT_PRICE_VOLUME_UNDER_1M3 : UNIT_PRICE_VOLUME_OVER_1M3;

    const priceVolume = volume_m3 * unitPriceVolume * EXCHANGE_RATE;
    const priceWeight = weight * UNIT_PRICE_WEIGHT;

    return Math.max(priceWeight, priceVolume);
  };

  return (
    <div className="p-8 border-2 rounded-lg shadow-lg max-w-lg mx-auto bg-gray-100">
      <h2 className="text-2xl font-bold text-center mb-6">
        Тээврийн зардал тооцоолуур
      </h2>

      {/* Хэмжээ */}
      {Object.entries(dimensions).map(([key, value]) => (
        <div key={key} className="mt-4 flex items-center gap-4">
          <span className="w-[80px] font-medium">{key}:</span>
          <Slider
            value={value}
            onChange={(_, newValue) =>
              setDimensions((prev) => ({ ...prev, [key]: newValue }))
            }
            min={1}
            max={200}
            sx={{ flexGrow: 1, color: "#6b8e23" }}
          />
          <TextField
            type="number"
            value={value}
            onChange={(e) =>
              setDimensions((prev) => ({
                ...prev,
                [key]: Number(e.target.value) || 1,
              }))
            }
            size="small"
            sx={{ width: 100 }}
            inputProps={{ min: 1, max: 200, style: { textAlign: "center" } }}
          />
          <span>см</span>
        </div>
      ))}

      {/* Жин */}
      <div className="mt-6 flex items-center gap-4">
        <span className="w-[80px] font-medium">Жин:</span>
        <Slider
          value={weight}
          onChange={(_, newValue) => setWeight(newValue)}
          min={1}
          max={1000}
          sx={{ flexGrow: 1, color: "#6b8e23" }}
        />
        <TextField
          type="number"
          value={weight}
          onChange={(e) => setWeight(Number(e.target.value) || 1)}
          size="small"
          sx={{ width: 100 }}
          inputProps={{ min: 1, max: 1000, style: { textAlign: "center" } }}
        />
        <span>кг</span>
      </div>

      {/* Нийт үнэ */}
      <div className="mt-6 text-xl font-semibold text-center">
        Тээврийн зардал:{" "}
        <span className="text-green-600">
          {formatMoney(calculateTotalPrice())} ₮
        </span>
      </div>

      <div className="mt-2 text-sm text-center text-gray-700">
        Хагарч гэмтэх эрсдэлтэй барааг илгээхээс өмнө мэдэгдэнэ үү!
      </div>
    </div>
  );
}
